/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceAssessmentSummaryRequest {
    getFixupPrototypeFunction() { return ComplianceAssessmentSummaryRequest.fixupPrototype; }

    static newInstance(model: Partial<ComplianceAssessmentSummaryRequest>): ComplianceAssessmentSummaryRequest {
        let obj = Object.assign(new ComplianceAssessmentSummaryRequest(), model);
        ComplianceAssessmentSummaryRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceAssessmentSummaryRequest>): ComplianceAssessmentSummaryRequest {
        if (!model) return null;
        return ComplianceAssessmentSummaryRequest.newInstance(<ComplianceAssessmentSummaryRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceAssessmentSummaryRequest) {
        if (!obj) return;

        models.ComplianceAssessmentSummaryRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceAssessmentSummaryRequest): boolean {
        Object.setPrototypeOf(obj, ComplianceAssessmentSummaryRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.query) {
            models.QueryOperator.fixupPrototype(this.query);
        }
    }

    /**
     * Unique assessment job number for filtering the summary
     */
    assessment_job_number: string;

    /**
     * Group by field
     */
    group_by: models.AssessmentSummaryGroupBy;

    /**
     * Count by field
     */
    count_by: models.AssessmentSummaryCountBy;

    /**
     * Tenant ID
     */
    tenant_id: string;

    /**
     * Query based on family, severity, and resource_type
     */
    query: models.QueryOperator;

}
